import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-confirmado-cadastro-estudante",
    templateUrl: "./confirmado-cadastro-estudante.component.html",
    styleUrls: ["./confirmado-cadastro-estudante.component.scss"],
})
export class ConfirmadoCadastroEstudanteComponent implements OnInit {
    emailEstudante: string = "";

    constructor(private router: Router) {}

    ngOnInit(): void {
        this.emailEstudante = history.state.emailEstudante;
    }

    handleVoltarLogin(): void {
        this.router.navigate(["/login"]);
    }
}
